module.exports = __webpack_public_path__ + "img/cooperation2.cf048997.png";